// Strategic Accounts and Vendor Contacts share the same pages and API
// shape; this is the per-kind wording and routing. Dave 2026-10-29.
export const ACCOUNT_KINDS = {
  strategic: {
    api: '/api/strategic-accounts',
    path: '/strategic-accounts',
    recordType: 'strategic_account',
    title: 'Strategic Accounts',
    single: 'Strategic Account',
    subtitle: 'Critical support contacts — quick access by company',
    empty: 'No strategic accounts yet. Add your first critical support contact with'
  },
  vendor: {
    api: '/api/vendor-contacts',
    path: '/vendor-contacts',
    recordType: 'vendor_contact',
    title: 'Vendor Contacts',
    single: 'Vendor Contact',
    subtitle: 'Suppliers and service providers — quick access by company',
    empty: 'No vendor contacts yet. Add your first vendor with'
  }
};

// Record page for any contact row, by record_type.
export function recordPathFor(recordType, id) {
  if (!id) return null;
  if (recordType === 'customer') return `/customers/${id}`;
  if (recordType === 'lead') return `/leads/${id}`;
  if (recordType === 'strategic_account') return `/strategic-accounts/${id}`;
  if (recordType === 'vendor_contact') return `/vendor-contacts/${id}`;
  if (recordType === 'distributor') return `/distributors/${id}`;
  return null;
}
